import { PARTNERSHIP_INCLUDES, FUTURE_MODULES } from "../content";
import { Reveal } from "../motion";
import { Section, Wrap, SectionHead, Eyebrow } from "./Section";

export default function Partnership() {
  return (
    <Section id="partnership" theme="cream" className="py-16 sm:py-24">
      <Wrap>
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <SectionHead
              eyebrow="Ongoing partnership"
              title="Care does not end at launch."
              intro="A calm monthly rhythm keeps the platform secure, current and improving, while the future stays open."
            />
            <Reveal delay={3} className="mt-10">
              <div className="bg-[#26342E] text-[#F6F0E6] rounded-3xl p-8 sm:p-10" data-testid="retainer-card">
                <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#C29A4A]">Proposed monthly care</p>
                <p className="font-serif font-light text-5xl sm:text-6xl mt-4">
                  R4 500
                  <span className="text-lg text-[#F6F0E6]/55 font-sans font-normal tracking-wide"> / month</span>
                </p>
                <p className="text-xs text-[#F6F0E6]/45 mt-2 tracking-wide">excluding VAT</p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pt-8">
            <ul className="divide-y divide-[#26342E]/10 border-t border-b border-[#26342E]/10">
              {PARTNERSHIP_INCLUDES.map((item, i) => (
                <Reveal key={item} delay={i * 0.4}>
                  <li className="flex items-center gap-4 py-5 text-[#26342E]/85">
                    <span className="font-serif italic text-lg text-[#B66E50] w-7 shrink-0">0{i + 1}</span>
                    <span className="text-sm sm:text-base">{item}</span>
                  </li>
                </Reveal>
              ))}
            </ul>

            <Reveal delay={2} className="mt-12">
              <Eyebrow>Where this can grow</Eyebrow>
              <p className="text-sm text-[#26342E]/60 mt-3 max-w-lg leading-relaxed">
                Future modules, quoted separately when the time is right; not part of the current proposal.
              </p>
              <div className="flex flex-wrap gap-2.5 mt-6" data-testid="future-modules">
                {FUTURE_MODULES.map((m) => (
                  <span
                    key={m}
                    className="text-xs font-medium text-[#4D5D4C] border border-[#6F806E]/35 bg-[#E6E8DE]/60 px-4 py-2.5 rounded-full transition-[background-color,border-color,transform] duration-300 hover:bg-[#E6E8DE] hover:-translate-y-0.5 cursor-default"
                  >
                    {m}
                  </span>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </Wrap>
    </Section>
  );
}
